import { testTemplateService } from '../services/testTemplateService';

import { TestTemplateBody } from '../types/TestTemplateBody';
import { TypeOfGoalBody } from '../types/TypeOfGoalBody';
import { TypeOfSubjectBody } from '../types/TypeOfSubjectBody';
import { ContentSubType } from '../types/ContentSubTypeBody';
import { TypeOfTestTemplateBody } from '../types/TypeOfTestTemplateBody';
import { ServerAlertAction } from '../../common'

const SHOW_ALERT = 'SHOW_ALERT';

let testTemplateList = (skip: number, type: string, typeId?: string,serachQuery?:string) => {

    let success = (data: TestTemplateBody[]) => ({ type: 'TestTemplateList_SUCCESS', data });
    let failure = (error: boolean) => ({ type: 'TestTemplateList_FAILED', error });

    return async (dispatch: any) => {
        try {
            const result = await testTemplateService.getTestTemplateList(
                skip,
                type,
                typeId,
                serachQuery
            );
            dispatch(success(result));
            return result;
        } catch (err) {
            dispatch(failure(err));
            return err;
        }
    };
}

const getTypeOfGoal = (bucketType?: string) => {

    let success = (data: TypeOfGoalBody[]) => ({ type: 'TypeOfGoal_SUCCESS', data });
    let failure = (error: string) => ({ type: 'TypeOfGoal_FAILED', error });
    return (dispatch: any) => {
        testTemplateService.getTypeOfGoal(bucketType)
            .then(
                (res) => {
                    dispatch(success(res));
                },
                (error: any) => {
                    dispatch(failure(error));
                }
            );
    }
}

let getSubject = (id: any) => {
    let success = (data: TypeOfSubjectBody[]) => ({ type: 'TypeOfSubject_SUCCESS', data });
    let failure = (error: string) => ({ type: 'TypeOfSubject_FAILED', error });

    return (dispatch: any) => {
        testTemplateService.getSubject(id)
            .then(
                (res) => {
                    dispatch(success(res));

                },
                (error: any) => {
                    dispatch(failure(error));
                }
            );
    }
}

let saveTestTemplate = (requestBody: TestTemplateBody) => {

    return testTemplateService.submitNewTemplate(requestBody)
        .then((res: any) => {
            if (res)
                return Promise.resolve(res);
            else
                return Promise.resolve(false);
        })
}

let updateTestTemplate = (requestBody: TestTemplateBody) => {
    return testTemplateService.updateNewTemplate(requestBody)
        .then((res: any) => {
            if (res)
                return Promise.resolve(res);
            else
                return Promise.resolve(false);
        })
}

let getContentSubType = (type: string) => {
    let success = (data: ContentSubType[]) => ({ type: 'contentSubType_SUCCESS', data });
    let failure = (error: string) => ({ type: 'contentSubType_FAILED', error });

    return (dispatch: any) => {
        testTemplateService.getContentSubType(type)
            .then(
                (res) => {
                    dispatch(success(res));
                },
                (error: any) => {
                    dispatch(failure(error));
                }
            );
    }
}

let getTestTemplateType = (subType: string, queryParam?: string) => {
    let success = (data: TypeOfTestTemplateBody[]) => ({ type: 'typeOfTestTemplate_SUCCESS', data });
    let failure = (error: string) => ({ type: 'typeOfTestTemplate_FAILED', error });

    return async (dispatch: any) => {
        try {
            const result = await testTemplateService.getContentSubType(subType, queryParam);
            dispatch(success(result));
            return result;
        } catch (err) {
            dispatch(failure(err));
            return err;
        }
    }
}


let saveNewTestType = (requestBody: any) => {
    return testTemplateService.submitNewTestType(requestBody)
}


let showMsg = (msg: string, vari: any) => {

    let showAlert = (message: string, variant: 'error' | 'success' = 'error'): ServerAlertAction => ({
        type: 'SHOW_ALERT', data: { message: message, variant: variant, openSnackbar: true }
    })
    return (dispatch: any) => {
        dispatch(showAlert(msg, vari));
    }
}

let deactiveTestType = (id: string) => {
    return testTemplateService.deactiveTestType(id)
        .then((res) => {
            return res;
        })
}

function showAlertToaster(message: string, variant: any): ServerAlertAction {
    return ({ type: SHOW_ALERT, data: { message, variant, openSnackbar: true } });
}
export {
    testTemplateList,
    getTypeOfGoal,
    getSubject,
    saveTestTemplate,
    updateTestTemplate,
    getContentSubType,
    getTestTemplateType,
    saveNewTestType,
    showMsg,
    deactiveTestType,
    showAlertToaster
}